import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#audit_rail",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Audit Rail View")
  ])
], -1)
const _hoisted_3 = {
  id: "audit_rail",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Type", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Responsible User", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4 justify-content-sm-end mt-8" }
const _hoisted_15 = {
  id: "trainer_data",
  class: "collapse show"
}
const _hoisted_16 = { class: "collapse show" }
const _hoisted_17 = { class: "card-body border-top p-6" }
const _hoisted_18 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = { key: 5 }
const _hoisted_25 = {
  key: 6,
  class: "align-centre"
}
const _hoisted_26 = { key: 7 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.entityList,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entityList) = $event)),
                  options: _ctx.Entity,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Entity",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Entity Type",
                  modelValue: _ctx.batch.user_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.user_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "--Select--",
                      value: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" --Select--")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeList, (employee) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: employee.user_id,
                        label: employee.name,
                        value: employee.user_id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(employee.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, " Search ")
              ])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.showCourseNotice == true)
      ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_Datatable, {
                    "table-data": _ctx.tableData,
                    "table-header": _ctx.tableHeader,
                    "enable-items-per-page-dropdown": true
                  }, {
                    "cell-entity_type": _withCtx(({ row: trainerList }) => [
                      _createTextVNode(_toDisplayString(trainerList.model_name), 1)
                    ]),
                    "cell-events": _withCtx(({ row: trainerList }) => [
                      (trainerList.action_type == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString('Created')))
                        : _createCommentVNode("", true),
                      (trainerList.action_type == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString('Edited')))
                        : _createCommentVNode("", true),
                      (trainerList.action_type == 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString('Approved')))
                        : _createCommentVNode("", true),
                      (trainerList.action_type == 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString('Rejected')))
                        : _createCommentVNode("", true),
                      (trainerList.action_type == 5)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString('Deleted')))
                        : _createCommentVNode("", true),
                      (trainerList.action_type == 6)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString('Inactive')))
                        : _createCommentVNode("", true),
                      (trainerList.action_type == 7)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString('Suspend')))
                        : _createCommentVNode("", true),
                      (trainerList.action_type == 8)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString('Active')))
                        : _createCommentVNode("", true)
                    ]),
                    "cell-user_id": _withCtx(({ row: trainerList }) => [
                      _createTextVNode(_toDisplayString(trainerList?.user_info?.employee?.name), 1)
                    ]),
                    "cell-actions": _withCtx(({ row: trainerList }) => [
                      _createElementVNode("button", {
                        "data-kt-drawer-toggle": "true",
                        "data-kt-drawer-target": "#kt_drawer_audit_view",
                        onClick: ($event: any) => (_ctx.view(trainerList)),
                        id: "kt_drawer_audit_view_button",
                        title: "View",
                        class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1"
                      }, _hoisted_29, 8, _hoisted_27)
                    ]),
                    _: 1
                  }, 8, ["table-data", "table-header"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}